import type { InferRequestType, InferResponseType } from 'hono/client';
import { client } from '@/utils/client';
export type GetRoleMenusReq = InferRequestType<(typeof client.api.common.role)['role-menus']['$get']>['query'];
export type GetRoleMenusRes = NonNullable<InferResponseType<(typeof client.api.common.role)['role-menus']['$get'], 200>['data']>;
export type GetListReq = InferRequestType<typeof client.api.common.role.$get>['query'];
export type GetListRes = NonNullable<InferResponseType<typeof client.api.common.role.$get, 200>['data']>;
export type GetListItem = NonNullable<GetListRes['items']>[number];
export type GetDetailRes = NonNullable<InferResponseType<(typeof client.api.common.role)[':id']['$get'], 200>['data']>;
export type CreateReq = InferRequestType<typeof client.api.common.role.$post>['json'];
export type CreateRes = NonNullable<InferResponseType<typeof client.api.common.role.$post, 200>['data']>;
export type UpdateReq = InferRequestType<(typeof client.api.common.role)[':id']['$put']>['json'];
export const getRoleMenus = async (data: GetRoleMenusReq): Promise<GetRoleMenusRes> => {
  const res = await client.api.common.role['role-menus'].$get({ query: data });
  return (await res.json()).data as GetRoleMenusRes;
};
export const getList = async (params?: GetListReq): Promise<GetListRes> => {
  const res = await client.api.common.role.$get({ query: params || {} });
  return (await res.json()).data as GetListRes;
};
export const getDetail = async (id: number): Promise<GetDetailRes> => {
  const res = await client.api.common.role[':id'].$get({
    param: { id: String(id) },
  });
  return (await res.json()).data as GetDetailRes;
};
export const create = async (data: CreateReq): Promise<CreateRes> => {
  const res = await client.api.common.role.$post({ json: data });
  return (await res.json()).data as CreateRes;
};
export const update = async (id: number, data: UpdateReq): Promise<void> => {
  await client.api.common.role[':id'].$put({
    param: { id: String(id) },
    json: data,
  });
};
const deleteRecord = async (id: number): Promise<void> => {
  await client.api.common.role[':id'].$delete({ param: { id: String(id) } });
};
export { deleteRecord as delete };
